export default __webpack_public_path__ + "static/media/Care10.5d17045a.png";